<div class="container">
  <div class="page-container">
    <div class="title-bar">
      <div class="dashboard-title">Manage Regions</div>
    </div>

    <div *ngIf="isSuperAdmin">
      <mat-divider></mat-divider>
      <div class="subtitle-row">
        <button *ngIf="isSuperAdmin" color="primary" mat-stroked-button routerLink="/admin/manage-region/upload-region">
          Add New Region
        </button>
      </div>
    </div>
    <mat-divider></mat-divider>
  </div>

  <div class="table-container">
    <table [dataSource]="dataSource" mat-table aria-describedby="Region List">
      <ng-container matColumnDef="name">
        <th scope="col" *matHeaderCellDef mat-header-cell>
          <div class="header-with-sort">
            <span>Region Name</span>
          </div>
        </th>
        <td *matCellDef="let row" class="region-name" mat-cell>
          {{ row.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="refreshDate">
        <th scope="col" *matHeaderCellDef mat-header-cell>
          <div class="header-with-sort">
            <span>Refresh Date</span>
          </div>
        </th>
        <td *matCellDef="let row" class="region-name" mat-cell>
          {{ row.refreshDate }}
        </td>
      </ng-container>

      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr (click)="clickRow($event, row)" *matRowDef="let row; columns: displayedColumns" mat-row></tr>
    </table>
  </div>
</div>
